/**
 * withOrderMethod
 * HOC for wrapping the provided component with OrderMethodProvider
 */

import React from 'react'

import OrderMethodProvider from './order-method-provider'

export default function withOrderMethod(WrappedComponent) {
  return function OrderMethodProviderHOC(props) {
    return (
      <OrderMethodProvider>
        <WrappedComponent {...props} />
      </OrderMethodProvider>
    )
  }
}
